'use strict';

// Polyfills
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
    	Element.prototype.webkitMatchesSelector ||
    	function(s) {
      	    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
      	    while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
    	};
}

// Run all TTAM.ready queued callbacks
(function() {
    _.forEach(window.TTAM._callbacks, function(callback) {
        callback();
    });
})();

// Base initializers
(function() {
    TTAM.cart();
    TTAM.carousels();
    TTAM.chrome();
    TTAM.dropdownMenu.init();
    TTAM.consoleMessages();
    TTAM.drawers();
    TTAM.upgradeButton();
    TTAM.veil();
    TTAM.anchors();
    TTAM.fonts();
    TTAM.lazyLoad();
    TTAM.modals();
    TTAM.matchLoad();
    Tipped.create('.js-tooltip');
    TTAM.asyncInclude();
    TTAM.featureSwitches.init();
})();

//# sourceMappingURL=project.js.map